import { ApiService } from './../api.service';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContatoMensagem } from 'src/app/models/contato-mensagem.model';
import { daApi, listaDaApi, MAP_CONTATO_GERAL, MAP_MENSAGEM, ORDEM_MENSAGEM, paraApi, parametrosLista } from '../api-map';

@Injectable({
  providedIn: 'root'
})
export class ContatoService {

  constructor(
    private api: ApiService
  ) { }

  get(numeroPagina: number, registroPorPagina: number, ordenacao: string, sentidoOrdenacao: string, filtro?: string): Observable<MensagensApi> {
    const query = parametrosLista(numeroPagina, registroPorPagina, ordenacao, sentidoOrdenacao, filtro, ORDEM_MENSAGEM, 'date');

    return this.api.get('/message' + query).pipe(
      map((res: any) => {
        const lista = listaDaApi(res, MAP_MENSAGEM);
        return { ContatosMensagem: lista.itens, numeroPaginas: lista.numeroPaginas } as MensagensApi;
      })
    );
  }

  getById(id): Observable<any> {
    return this.api.get(`/message/${id}`).pipe(map((res: any) => daApi(res, MAP_MENSAGEM)));
  }

  post(mensagem: ContatoMensagem): Observable<any> {
    return this.api.post('/message', paraApi(mensagem, MAP_MENSAGEM));
  }

  patch(mensagem: ContatoMensagem): Observable<any> {
    return this.api.patch('/message', paraApi(mensagem, MAP_MENSAGEM));
  }

  delete(mensagem: ContatoMensagem): Observable<any> {
    return this.api.delete(`/message/${mensagem.id}`);
  }

  deleteSelected(mensagens: ContatoMensagem[]): Observable<any> {
    return this.api.deleteComCorpo('/message', mensagens.map(m => ({ id: m.id })));
  }

  // A API nova nao tem exportacao para Excel; a tela de mensagens ainda oferece o
  // botao, entao devolvemos um erro explicito em vez de bater numa rota inexistente.
  excel(): Observable<any> {
    return throwError({ error: 'Exportacao para Excel ainda nao existe na API nova.' });
  }

  buscarGeral() {
    return this.api.get('/contact').pipe(map((res: any) => res ? daApi(res, MAP_CONTATO_GERAL) : null));
  }

  alterarGeral(contatoGeral: any) {
    return this.api.post('/contact', paraApi(contatoGeral, MAP_CONTATO_GERAL));
  }
}

export interface MensagensApi {
  ContatosMensagem: ContatoMensagem[];
  numeroPaginas: number;
}
